<script>
    import { createEventDispatcher } from "svelte"
    import { _ } from "svelte-i18n"

    import Field from "src/form/Field.svelte"
    import File from "src/form/File.svelte"
    import Checkbox from "src/form/Checkbox.svelte"
    import { findObj } from "src/utility/misc"

    import data from "src/data.json"
    import { settings } from "src/settings.store"

    const dispatch = createEventDispatcher();

    $settings.boardType = $settings.boardType ? $settings.boardType : data.boardType[0].value;
    $settings.productName = $settings.productName ? $settings.productName : data.boardType[0].label;
    $settings.productNameColor = $settings.productNameColor ? $settings.productNameColor : "#FFFFFF";
    $settings.background = $settings.background ? $settings.background : "#000000";
    $settings.foreground = $settings.foreground ? $settings.foreground : "#FFFFFF";
    $settings.border = $settings.border ? $settings.border : data.border[0].value;
    $settings.iconTheme = $settings.iconTheme ? $settings.iconTheme : data.iconTheme[0].value;
    $settings.iconSet = $settings.iconSet ? $settings.iconSet : data.iconSet[0].value;
    $settings.iconNav = $settings.iconNav ? $settings.iconNav : data.iconBorder[0].value;
    $settings.iconUpDown = $settings.iconUpDown ? $settings.iconUpDown : data.iconBorder[0].value;
    $settings.logoDimension = $settings.logoDimension ? $settings.logoDimension : data.logoDimension[1].value;
    $settings.logoPosition = $settings.logoPosition ? $settings.logoPosition : data.logoPosition[0].value;

    $: logoPositions = data.logoPosition.filter(el => {
        if ($settings.logoMeccalte && el.value === "top-left") return;
        if ($settings.productName !== "" && el.value === "top-right") return;
        return el;
    });

    $: updateLogoPosition($settings.logoPosition);

    const updateLogoPosition = (logoPosition) => {
        if (!logoPositions.some(el => el.value === logoPosition)) {
            logoPosition = logoPositions[0].value;
        }
        $settings.logoPosition = logoPosition;
    };

    const handleBoardType = () => {
        $settings.productName = findObj(data.boardType, $settings.boardType, "value").label;
    };
</script>

<div class="pc__settings">
    <Field
        variant="board-type"
        type="select"
        label={$_('settings.boardType')}
        options={data.boardType}
        bind:value={$settings.boardType}
        on:change={handleBoardType} />
    <Field
        variant="product-name"
        type="text"
        label={$_('settings.productName')}
        placeholder={$_('settings.placeholder.productName')}
        bind:value={$settings.productName} />
    <Field
        variant="product-name-color"
        type="color"
        label={$_('settings.productNameColor')}
        bind:value={$settings.productNameColor} />
    <Field
        variant="background"
        type="color"
        label={$_('settings.background')}
        bind:value={$settings.background} />
    <Field
        variant="foreground"
        type="color"
        label={$_('settings.foreground')}
        bind:value={$settings.foreground} />
    <Checkbox
        variant="border-display"
        label={$_('settings.borderDisplay')}
        bind:checked={$settings.borderDisplay} />
    <Field
        variant="icon-theme"
        type="select"
        label={$_('settings.iconTheme')}
        options={data.iconTheme}
        bind:value={$settings.iconTheme} />
    <Field
        variant="icon-set"
        type="select"
        label={$_('settings.iconSet')}
        options={data.iconSet}
        bind:value={$settings.iconSet} />
    <Field
        variant="border"
        type="select"
        label={$_('settings.border')}
        options={data.border}
        bind:value={$settings.border} />
    <Field
        variant="icon-up-down"
        type="select"
        label={$_('settings.iconBorderUpDown')}
        options={data.iconBorder}
        bind:value={$settings.iconUpDown} />
    {#if findObj(data.boardType, $settings.boardType, "value").borderNav}
    <Field
        variant="icon-nav"
        type="select"
        label={$_('settings.iconBorderNav')}
        options={data.iconBorder}
        bind:value={$settings.iconNav} />
    {/if}
    {#if findObj(data.boardType, $settings.boardType, "value").ledText}
    <Checkbox
        variant="led-text"
        label={$_('settings.ledText')}
        bind:checked={$settings.ledText} />
    {/if}

    {#if $settings.logoMeccalte}
    <Field
        variant="logo-dimension"
        type="select"
        label={$_('settings.logoDimension')}
        options={data.logoDimension}
        bind:value={$settings.logoDimension} />
    {/if}

    <File
        variant="logo"
        label={$_('settings.logo')}
        bind:value={$settings.logo} />

    {#if $settings.logo}
    <Checkbox
        variant="logo-meccalte"
        label={$_('settings.logoMeccalte')}
        bind:checked={$settings.logoMeccalte} />
    <Field
        variant="logo-position"
        type="select"
        label={$_('settings.logoPosition')}
        options={logoPositions}
        bind:value={$settings.logoPosition} />
    {/if}
</div>

<button
    type="button"
    class="pc__button pc__button--primary pc__button--settings"
    on:click={() => dispatch("routeEvent", "contact")}>
    {$_('settings.proceed')}
</button>